import React, { useEffect, useState, useRef } from 'react';
import { Icon } from '@iconify/react';
import transportationVehicle from '@iconify-icons/mdi/transportation';
import GoogleMapReact from 'google-map-react';


const MiniMap = ({ vehiclePosition }) => {
    const [isMapLoading, setIsMapLoading] = useState(true); 
    const defaultZoom = 15;
    const createMiniMapOptions = (maps) => ({
        disableDefaultUI: true,
        gestureHandling: 'none',
        zoomControl: false,
        draggable: false,
        keyboardShortcuts: false,
        clickableIcons: false,
    });

    const MiniMarker = ({ text }) => (
        <div style={{
        color: 'red',
        fontSize: '18px',
        transform: 'translate(-50%, -100%)',
        }}>
        🚗
        </div>
    );

    const handleApiLoaded = ({ map, maps }) => {
        setTimeout(() => {
            setIsMapLoading(false);
        }, 2000);
    };


    return (
    <div style={{
        position: 'absolute',
        bottom: '10px',
        right: '10px',
        width: '150px',
        height: '150px',
        border: '2px solid #888',
        borderRadius: '8px',
        overflow: 'hidden',
        zIndex: 1000,
        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
        }}>
        {isMapLoading && (
        <div className="map-loader-overlay">
            <div className="map-loader-content">
            <div className="map-icon">   
                <Icon 
                icon={transportationVehicle} 
                width="40" 
                height="40" 
                style={{color: 'white'}}
                />
            </div>
            <div style={{fontSize: "14px", color: "white"}}>Loading...</div>
            </div>
        </div>
        )}
        <GoogleMapReact
            bootstrapURLKeys={{ key: 'AIzaSyCUZiQELkgLvz9RFYDCl4Lsetn3H54jaXI' }}
            onGoogleApiLoaded={handleApiLoaded}
            defaultCenter={vehiclePosition}
            defaultZoom={defaultZoom}
            options={createMiniMapOptions}
        >
            <MiniMarker lat={vehiclePosition.lat} lng={vehiclePosition.lng} />
        </GoogleMapReact>
    </div>
  );
};

export default MiniMap;
